import React from 'react';
import { motion } from 'framer-motion';
import { Mail, BookOpen, Map, CalendarClock, ArrowRight, Sparkles } from 'lucide-react';
const bonos = [{
  icon: Mail,
  title: 'Bono 1 — Kit de 15 cartas listas para enviar',
  desc: 'Modelos ya redactados para los reclamos más frecuentes. Solo completás tus datos entre corchetes y enviás.',
  color: 'blue'
}, {
  icon: BookOpen,
  title: 'Bono 2 — Glosario ciudadano: 40 términos legales en castellano',
  desc: 'Todo lo que aparece en formularios y resoluciones, traducido a lenguaje humano de una vez por todas.',
  color: 'blue'
}, {
  icon: Map,
  title: 'Bono 3 — Mapa de organismos: a quién llamar según tu problema',
  desc: 'SRT, BCRA, SSS, ENACOM, Defensa del Consumidor y más: qué hace cada uno y cuándo ir.',
  color: 'blue'
}, {
  icon: CalendarClock,
  title: 'Bono 4 — Calculadora de plazos legales',
  desc: 'Tabla completa de todos los plazos críticos por tipo de reclamo. Nunca más pierdas un derecho por dejar pasar el tiempo.',
  isExclusive: true
}];
export function Bonos() {
  return <section className="py-12 md:py-[70px] px-5 bg-off-white" data-id="element-1">
      <div className="max-w-[860px] mx-auto" data-id="element-2">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-blue mb-2" data-id="element-3">
          Incluidos gratis
        </div>
        <h2 className="font-display text-[clamp(28px,6vw,52px)] text-navy mb-2 leading-tight" data-id="element-4">
          4 Bonos estratégicos
        </h2>
        <p className="text-[14px] md:text-[16px] text-text-muted max-w-[560px] mb-6 md:mb-9" data-id="element-5">
          Sin costo extra — incluidos en todas las ofertas.
        </p>

        <div className="space-y-2.5 md:space-y-3" data-id="element-6">
          {bonos.map((bono, i) => {
          const Icon = bono.icon;
          const isExclusive = !!bono.isExclusive;
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} whileTap={{
            scale: 0.99
          }} whileHover={{
            x: 4
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className={`relative flex items-center gap-3 md:gap-4 bg-white rounded-xl p-3.5 md:p-5 cursor-pointer group transition-all border ${isExclusive ? 'border-gold border-l-[4px] shadow-md' : 'border-border border-l-[4px] border-l-success hover:shadow-md'}`} data-id="element-7">
                {/* Icon container */}
                <div className={`flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center ${isExclusive ? 'bg-gold/15 text-gold' : 'bg-success/10 text-success'}`} data-id="element-8">
                  <Icon size={26} strokeWidth={1.8} data-id="element-9" />
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0" data-id="element-10">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5" data-id="element-11">
                    <h4 className="text-[13px] md:text-[15px] font-bold text-navy leading-tight" data-id="element-12">
                      {bono.title}
                    </h4>
                    <span className={`inline-flex items-center gap-0.5 text-[9px] md:text-[10px] font-extrabold py-0.5 px-2 rounded-full tracking-[0.06em] ${isExclusive ? 'bg-gold text-navy' : 'bg-success text-white'}`} data-id="element-13">
                      {isExclusive && <Sparkles size={9} fill="currentColor" data-id="element-14" />}
                      {isExclusive ? 'EXCLUSIVO' : 'GRATIS'}
                    </span>
                  </div>
                  <p className="text-[12px] md:text-[13px] text-text-muted leading-snug" data-id="element-15">
                    {bono.desc}
                  </p>
                </div>

                <ArrowRight size={16} className={`flex-shrink-0 transition-all group-hover:translate-x-0.5 hidden sm:block ${isExclusive ? 'text-gold' : 'text-success/50 group-hover:text-success'}`} data-id="element-16" />
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-5 md:mt-7 p-4 md:p-5 bg-sky rounded-xl border border-border" data-id="element-17">
          <strong className="block text-[15px] md:text-[20px] text-navy" data-id="element-18">
            VALOR TOTAL DE LOS BONOS: $28.000 — INCLUIDOS SIN COSTO ADICIONAL
          </strong>
          <span className="block text-[12px] md:text-[14px] text-text-muted mt-1" data-id="element-19">
            En todas las ofertas, desde el primer día.
          </span>
        </div>
      </div>
    </section>;
}